import type { ColumnDef } from '@tanstack/react-table';
import { columnaAcciones, columnaCalculada, columnaNumero, columnaSelect, columnaTexto } from '../../../globales/componentes/tabla/columnasEditables';
import type { IConceptoCostoPostventa, IRepuestoPostventa } from '../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';

/** Repuestos por unidad. El subtotal en COP lo entrega el back al calcular. */
export const columnasRepuestos = (
    incoterms: { value: string; label: string }[],
    subtotal: (repuesto: IRepuestoPostventa) => number | undefined
): ColumnDef<IRepuestoPostventa>[] => [
    columnaAcciones<IRepuestoPostventa>(),
    columnaTexto<IRepuestoPostventa>('Item', 'Ítem'),
    columnaNumero<IRepuestoPostventa>('CostoUnitario', 'Costo unitario', { decimales: 2 }),
    columnaNumero<IRepuestoPostventa>('Cantidad', 'Cantidad'),
    columnaNumero<IRepuestoPostventa>('Trm', 'TRM', { decimales: 2 }),
    columnaSelect<IRepuestoPostventa>('IncotermId', 'Incoterm', incoterms),
    columnaTexto<IRepuestoPostventa>('Detalle', 'Detalle', false),
    columnaCalculada<IRepuestoPostventa>('subtotal', 'Subtotal (COP)', subtotal, { prefijo: '$ ' })
];

/** Transportes, viáticos, know-how y otros costos: ítem, costo en COP y detalle. */
export const columnasConceptos = (): ColumnDef<IConceptoCostoPostventa>[] => [
    columnaAcciones<IConceptoCostoPostventa>(),
    columnaTexto<IConceptoCostoPostventa>('Item', 'Ítem'),
    columnaNumero<IConceptoCostoPostventa>('Costo', 'Costo (COP)', { prefijo: '$ ' }),
    columnaTexto<IConceptoCostoPostventa>('Detalle', 'Detalle', false)
];
